import { useQuery } from '@tanstack/react-query'
import { getCommentMarkers } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseCommentMarkersOptions {
  enabled?: boolean
}

/**
 * コメントマーカー（未読コメント数）を取得するカスタムフック
 *
 * @param opportunityId - オポチュニティID
 * @param options - フックオプション
 * @returns TanStack Query の結果
 */
export function useCommentMarkers(opportunityId: number, options: UseCommentMarkersOptions = {}) {
  const { enabled = true } = options

  return useQuery({
    queryKey: queryKeys.opportunity.commentMarkers(opportunityId),
    queryFn: async () => {
      return getCommentMarkers(opportunityId)
    },
    enabled: enabled && opportunityId > 0,
  })
}
